module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-55-min.80ca8704.jpg";